// Components
import { Stack } from "@mui/material";

// Constants
import DarthVaderBlob from "../Assets/MBS_darth_blob.svg";
import SkywalkerBlob from "../Assets/MBS_sky_blob.svg";
import { MODES } from "Constants/theme";

const BackgroundBlob = ({ mode, withNavbarOffset = false }) => {
  const backgroundBlob = mode === MODES.DARK ? DarthVaderBlob : SkywalkerBlob;

  return (
    <Stack
      aria-hidden="true"
      sx={{
        display: "block",
        position: "absolute",
        left: "50%",
        top: withNavbarOffset ? "calc(50% + 2.6rem)" : "50%",
        transform: "translate(-50%, -50%)",
        width: { xs: "90%", md: "80%" },
        maxHeight: "700px",
        maxWidth: "850px",
        zIndex: 0,
        pointerEvents: "none",
      }}
    >
      <Stack
        component="img"
        src={backgroundBlob}
        alt=""
        sx={{ width: "100%", height: "100%", display: "block" }}
      />
    </Stack>
  );
};

export default BackgroundBlob;
